import { initializeApp } from "firebase/app";
import { getStorage } from "firebase/storage";
import { getFirestore, collection, getDocs } from "firebase/firestore";
import { getAuth } from "firebase/auth";


const firebaseConfig = {
    apiKey: "AIzaSyDTrZqOHcER8eKahMX5YN8xCmHLmwLATnE",
    authDomain: "erosmodels.firebaseapp.com",
    projectId: "erosmodels",
    storageBucket: "erosmodels.firebasestorage.app",
    messagingSenderId: "1096528025405",
    appId: "1:1096528025405:web:8e9b2de7dedf6de861d754",
    measurementId: "G-FCTGXWWDFZ"
  };

  const app = initializeApp(firebaseConfig);
  const db = getFirestore(app);
  const storage = getStorage(app);
  const auth = getAuth(app);
  
  export {app, db,storage,auth, collection, getDocs };